const key = 'auth'

export function selectAuth(state) {
  return state[key]
}

export function selectAuthConfigs(state) {
  return selectAuth(state).configs
}

export function selectAuthInteractiveCheck(state) {
  const {inIframe, oos, oosWithInfo} = selectAuth(state)
  return (inIframe || oos || oosWithInfo)
}